export default __webpack_public_path__ + "static/media/Publications.2070544f.svg";